<app-hero [title]="'changePassword.private.changePassword' | translate" />
<div class="container-xxl">
	<div>
		<form
			[formGroup]="changePasswordForm"
			(submit)="!changePasswordForm.invalid && changePassword()"
		>
			<section class="form">
				<div class="field col-sm-12">
					<p
						dir="ltr"
						[innerHTML]="'passwordFormat' | translate"
					></p>
				</div>

				<div class="field col-sm-offset-3 col-sm-6">
					<label for="b2bCambioPwd_newPwd">{{ "changePassword.private.newPassword" | translate }}</label>
					<input
						[type]="showPasswords ? 'text' : 'password'"
						id="b2bCambioPwd_newPwd"
						name="b2bCambioPwd_newPwd"
						formControlName="password"
						maxlength="20"
						[class.border-red]="changePasswordForm.controls.password.invalid && changePasswordForm.controls.password.touched"
					/>
				</div>

				<div class="field col-sm-offset-3 col-sm-6">
					<label for="b2bCambioPwd_confirmPwd">{{ "changePassword.private.confirmPassword" | translate }}</label>
					<input
						[type]="showPasswords ? 'text' : 'password'"
						id="b2bCambioPwd_confirmPwd"
						name="b2bCambioPwd_confirmPwd"
						formControlName="confPassword"
						maxlength="20"
						[class.border-red]="changePasswordForm.controls.confPassword.invalid && changePasswordForm.controls.confPassword.touched"
					/>
				</div>

				<div class="col-sm-12 text-center">
					<button
						type="submit"
						[class.disabled]="changePasswordForm.invalid"
						class="btn btn-red"
					>
						{{ "changePassword.private.change" | translate }}
					</button>
					<br class="d-lg-none" />
					<button
						type="button"
						class="btn btn-blue mt-3 mt-lg-0 ms-lg-4"
						(click)="suggestPassword()"
					>
						{{ "changePassword.generatePassword" | translate }}
					</button>
				</div>
			</section>
		</form>
	</div>
</div>